import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import ModalContainer from '../../../ModalContainer/ModelContainer'

import SelectGiftTypeView from './components/SelectGiftTypeView/SelectGiftTypeView'
import External from './components/External/External'
import Custom from './components/Custom/Custom'
import RewardLink from './components/RewardLink/RewardLink'

const RewardsSendGiftModal = ({
  onClose = () => {},
  selectedBuilding,
  lockResident,
  onSuccess,
}) => {
  const { t } = useTranslation(['rewards-gift'])
  const [giftType, setGiftType] = useState('')

  useEffect(() => () => setGiftType(''), [])

  const componentsByType = {
    external: (
      <External
        goBack={() => setGiftType('')}
        closePopup={onClose}
        selectedBuilding={selectedBuilding}
        lockResident={lockResident}
        onSuccess={onSuccess}
      />
    ),
    amenity: (
      <Custom
        type="amenity"
        goBack={() => setGiftType('')}
        selectedBuilding={selectedBuilding}
        closePopup={onClose}
        lockResident={lockResident}
        onSuccess={onSuccess}
      />
    ),
    services: (
      <Custom
        type="services"
        goBack={() => setGiftType('')}
        selectedBuilding={selectedBuilding}
        closePopup={onClose}
        lockResident={lockResident}
        onSuccess={onSuccess}
      />
    ),
    link: (
      <RewardLink
        goBack={() => setGiftType('')}
        selectedBuilding={selectedBuilding}
        closePopup={onClose}
        lockResident={lockResident}
        onSuccess={onSuccess}
      />
    ),
  }

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards-gift:sendGiftHeaderTitle')}
      headerIcon={<Icon icon="cardSend" viewBox="0 0 18 21" svgProps={{ fillRule: 'evenodd' }} />}
    >
      {giftType ? (
        componentsByType[giftType]
      ) : (
        <SelectGiftTypeView onClose={onClose} onNext={setGiftType} />
      )}
    </ModalContainer>
  )
}

RewardsSendGiftModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedBuilding: PropTypes.object,
  lockResident: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
    email: PropTypes.string,
    phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onSuccess: PropTypes.func,
}

export default RewardsSendGiftModal
